import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import settings from '@/utils/settings'
import { translate } from '@/utils/translations'

const AccessibilityFeatures = () => {
  const iframeRef = useRef(null)
  const [iframeHeight, setIframeHeight] = useState('400px')
  const handleIframeLoad = () => {
    if (iframeRef.current && iframeRef.current.contentDocument) {
      const body = iframeRef.current.contentDocument.body
      setIframeHeight(body.scrollHeight + 'px')
    }
  }
  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.addEventListener('load', handleIframeLoad)
    }
  }, [])
  const asset = useSelector(state => state.asset)
  const vbid = asset.vbid
  const locale = useSelector(state => state.currentLocale.locale)
  return (
    <iframe
      allowFullScreen
      frameBorder="0"
      height={iframeHeight}
      id='accessibility-panel-iframe'
      onLoad={handleIframeLoad}
      ref={iframeRef}
      src={`${settings.a11yPanelUrl}?vbid=${vbid}&locale=${locale}&theme=ocean`}
      style={{ border: 'none' }}
      title={`${translate('product_display.accessibility.accessibility')}`}
      width="100%"
    />
  )
}

export default AccessibilityFeatures
